//accesses defsites.json, returns a pair of arrays
//first one contains sites with listname (aka the one designed in creator)
export function divideDefsitesByOrigin() {
    const defSites = require("../assets/defSites.json");
    const staticSites = require("../assets/staticElements.json");
    const sitesWithListName = [];
    defSites.forEach(element => {
        if (element.coded) {
            sitesWithListName.push(element);
        }

        //CODE ABOVE IS TO REFACTOR
        //if all creator pages will be divided into parts then replace if else statement with commented version and remove "coded" property from objects in defSites.json
    });
    return { creatorPages: sitesWithListName, staticSites: staticSites };
}

export function getCreatorDefsites() {
    const defSites = require('../assets/defSites.json');
    const sitesWithListName = [];
    defSites.forEach(element => {
        if (element.listName){
            if(!element.creatorPath) {
                throw new TypeError(`Element with listname ${element.listName} doesn't have creatorPath specified. Check assets/defsites.json`)
            }
            if(!element.pageTranslationKey) {
                throw new TypeError(`Element with listname ${element.listName} doesn't have pageTranslationKey specified. Check assets/defsites.json`)
            }
            sitesWithListName.push(element);
        }
    });
    return sitesWithListName;
}
